import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=ca3b4dc0&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=ca3b4dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3b4dc0",
  null
  
)

export default component.exports